import { createActions, createReducer } from 'reduxsauce'

const situacoes = [
    { value: '', label: 'Todas' },
    { value: 'A', label: 'Ativo' },
    { value: 'E', label: 'Encerrado' },
    { value: 'R', label: 'Rescindido' },
]

/**
 * Action types & creators
 */

export const { Types, Creators } = createActions({
    setExercicioInicialConsultaConveniosInstrumentosCongeneres: ['exercicioInicial'],
    setExercicioFinalConsultaConveniosInstrumentosCongeneres: ['exercicioFinal'],
    setCodigoInicialConsultaConveniosInstrumentosCongeneres: ['codigoInicial'],
    setCodigoFinalConsultaConveniosInstrumentosCongeneres: ['codigoFinal'],
    setAssinaturaInicialConsultaConveniosInstrumentosCongeneres: ['assinaturaInicial'],
    setAssinaturaFinalConsultaConveniosInstrumentosCongeneres: ['assinaturaFinal'],
    setTipoConsultaConveniosInstrumentosCongeneres: ['tipo'],
    setAdministracaoConsultaConveniosInstrumentosCongeneres: ['administracao'],
    setDescricaoLocalFisicoConsultaConveniosInstrumentosCongeneres: ['descricaoLocalFisico'],
    setConvenenteConsultaConveniosInstrumentosCongeneres: ['convenente'],
    setIdentificacaoExternaConsultaConveniosInstrumentosCongeneres: ['identificacaoExterna'],
    setUnidadeGestoraConsultaConveniosInstrumentosCongeneres: ['unidadeGestora'],
    setConcedenteConsultaConveniosInstrumentosCongeneres: ['concedente'],
    setIntervenienteConsultaConveniosInstrumentosCongeneres: ['interveniente'],
    setObjetoConsultaConveniosInstrumentosCongeneres: ['objeto'],
    setSituacaoConsultaConveniosInstrumentosCongeneres: ['situacao'],
    setExercicioLicitacaoInicialConsultaConveniosInstrumentosCongeneres: ['exercicioLicitacaoInicial'],
    setExercicioLicitacaoFinalConsultaConveniosInstrumentosCongeneres: ['exercicioLicitacaoFinal'],
    setNumeroLicitacaoInicialConsultaConveniosInstrumentosCongeneres: ['numeroLicitacaoInicial'],
    setNumeroLicitacaoFinalConsultaConveniosInstrumentosCongeneres: ['numeroLicitacaoFinal'],
    setModalidadeLicitacaoConsultaConveniosInstrumentosCongeneres: ['modalidadeLicitacao'],
    limpaFiltroConsultaConveniosInstrumentosCongeneres: [],
    receberFiltroConsultaConveniosInstrumentosCongeneres: ['filtroRecebido'],
})

const INITIAL_STATE = {
    exercicioInicial: new Date().getFullYear(),
    exercicioFinal: new Date().getFullYear(),
    codigoInicial: '',
    codigoFinal: '',
    assinaturaInicial: '',
    assinaturaFinal: '',
    tipo: '',
    administracao: '',
    descricaoLocalFisico: '',
    convenente: '',
    concedente: '',
    interveniente: '',
    identificacaoExterna: '',
    unidadeGestora: '',
    objeto: '',
    situacao: { value: situacoes[0].value, label: situacoes[0].label },
    exercicioLicitacaoInicial: '',
    exercicioLicitacaoFinal: '',
    numeroLicitacaoInicial: '',
    numeroLicitacaoFinal: '',
    modalidadeLicitacao: '',
}

const setExercicioInicial = (state = INITIAL_STATE, action) => {
    return { ...state, exercicioInicial: action.exercicioInicial }
}
const setExercicioFinal = (state = INITIAL_STATE, action) => {
    return { ...state, exercicioFinal: action.exercicioFinal }
}
const setCodigoInicial = (state = INITIAL_STATE, action) => {
    return { ...state, codigoInicial: action.codigoInicial }
}
const setCodigoFinal = (state = INITIAL_STATE, action) => {
    return { ...state, codigoFinal: action.codigoFinal }
}
const setAssinaturaInicial = (state = INITIAL_STATE, action) => {
    return { ...state, assinaturaInicial: action.assinaturaInicial }
}
const setAssinaturaFinal = (state = INITIAL_STATE, action) => {
    return { ...state, assinaturaFinal: action.assinaturaFinal }
}
const setTipo = (state = INITIAL_STATE, action) => {
    return { ...state, tipo: action.tipo }
}
const setAdministracao = (state = INITIAL_STATE, action) => {
    return { ...state, administracao: action.administracao }
}
const setDescricaoLocalFisico = (state = INITIAL_STATE, action) => {
    return { ...state, descricaoLocalFisico: action.descricaoLocalFisico }
}
const setConvenente = (state = INITIAL_STATE, action) => {
    return { ...state, convenente: action.convenente }
}
const setConcedente = (state = INITIAL_STATE, action) => {
    return { ...state, concedente: action.concedente }
}
const setInterveniente = (state = INITIAL_STATE, action) => {
    return { ...state, interveniente: action.interveniente }
}
const setIdentificacaoExterna = (state = INITIAL_STATE, action) => {
    return { ...state, identificacaoExterna: action.identificacaoExterna }
}
const setUnidadeGestora = (state = INITIAL_STATE, action) => {
    return { ...state, unidadeGestora: action.unidadeGestora }
}
const setObjeto = (state = INITIAL_STATE, action) => {
    return { ...state, objeto: action.objeto }
}
const setSituacao = (state = INITIAL_STATE, action) => {
    return { ...state, situacao: action.situacao }
}
const setExercicioLicitacaoInicial = (state = INITIAL_STATE, action) => {
    return { ...state, exercicioLicitacaoInicial: action.exercicioLicitacaoInicial }
}
const setExercicioLicitacaoFinal = (state = INITIAL_STATE, action) => {
    return { ...state, exercicioLicitacaoFinal: action.exercicioLicitacaoFinal }
}
const setNumeroLicitacaoInicial = (state = INITIAL_STATE, action) => {
    return { ...state, numeroLicitacaoInicial: action.numeroLicitacaoInicial }
}
const setNumeroLicitacaoFinal = (state = INITIAL_STATE, action) => {
    return { ...state, numeroLicitacaoFinal: action.numeroLicitacaoFinal }
}
const setModalidadeLicitacao = (state = INITIAL_STATE, action) => {
    return { ...state, modalidadeLicitacao: action.modalidadeLicitacao }
}
const limpaFiltro = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}
const receberFiltro = (state = INITIAL_STATE, action) => {
    return action.filtroRecebido
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.SET_EXERCICIO_INICIAL_CONSULTA_CONVENIOS_INSTRUMENTOS_CONGENERES]: setExercicioInicial,
    [Types.SET_EXERCICIO_FINAL_CONSULTA_CONVENIOS_INSTRUMENTOS_CONGENERES]: setExercicioFinal,
    [Types.SET_CODIGO_INICIAL_CONSULTA_CONVENIOS_INSTRUMENTOS_CONGENERES]: setCodigoInicial,
    [Types.SET_CODIGO_FINAL_CONSULTA_CONVENIOS_INSTRUMENTOS_CONGENERES]: setCodigoFinal,
    [Types.SET_ASSINATURA_INICIAL_CONSULTA_CONVENIOS_INSTRUMENTOS_CONGENERES]: setAssinaturaInicial,
    [Types.SET_ASSINATURA_FINAL_CONSULTA_CONVENIOS_INSTRUMENTOS_CONGENERES]: setAssinaturaFinal,
    [Types.SET_TIPO_CONSULTA_CONVENIOS_INSTRUMENTOS_CONGENERES]: setTipo,
    [Types.SET_ADMINISTRACAO_CONSULTA_CONVENIOS_INSTRUMENTOS_CONGENERES]: setAdministracao,
    [Types.SET_DESCRICAO_LOCAL_FISICO_CONSULTA_CONVENIOS_INSTRUMENTOS_CONGENERES]: setDescricaoLocalFisico,
    [Types.SET_CONVENENTE_CONSULTA_CONVENIOS_INSTRUMENTOS_CONGENERES]: setConvenente,
    [Types.SET_CONCEDENTE_CONSULTA_CONVENIOS_INSTRUMENTOS_CONGENERES]: setConcedente,
    [Types.SET_INTERVENIENTE_CONSULTA_CONVENIOS_INSTRUMENTOS_CONGENERES]: setInterveniente,
    [Types.SET_OBJETO_CONSULTA_CONVENIOS_INSTRUMENTOS_CONGENERES]: setObjeto,
    [Types.SET_SITUACAO_CONSULTA_CONVENIOS_INSTRUMENTOS_CONGENERES]: setSituacao,
    [Types.SET_IDENTIFICACAO_EXTERNA_CONSULTA_CONVENIOS_INSTRUMENTOS_CONGENERES]: setIdentificacaoExterna,
    [Types.SET_UNIDADE_GESTORA_CONSULTA_CONVENIOS_INSTRUMENTOS_CONGENERES]: setUnidadeGestora,
    [Types.SET_EXERCICIO_LICITACAO_INICIAL_CONSULTA_CONVENIOS_INSTRUMENTOS_CONGENERES]: setExercicioLicitacaoInicial,
    [Types.SET_EXERCICIO_LICITACAO_FINAL_CONSULTA_CONVENIOS_INSTRUMENTOS_CONGENERES]: setExercicioLicitacaoFinal,
    [Types.SET_NUMERO_LICITACAO_INICIAL_CONSULTA_CONVENIOS_INSTRUMENTOS_CONGENERES]: setNumeroLicitacaoInicial,
    [Types.SET_NUMERO_LICITACAO_FINAL_CONSULTA_CONVENIOS_INSTRUMENTOS_CONGENERES]: setNumeroLicitacaoFinal,
    [Types.SET_MODALIDADE_LICITACAO_CONSULTA_CONVENIOS_INSTRUMENTOS_CONGENERES]: setModalidadeLicitacao,
    [Types.LIMPA_FILTRO_CONSULTA_CONVENIOS_INSTRUMENTOS_CONGENERES]: limpaFiltro,
    [Types.RECEBER_FILTRO_CONSULTA_CONVENIOS_INSTRUMENTOS_CONGENERES]: receberFiltro,
})
